import {
  createSimpleListActions,
  createGetActions
} from "reducers/higherOrderReducers";

export const ACTION_TYPE = {
  INPUT: createGetActions("INPUT"),
  // User Input
  INTEREST: createSimpleListActions("INTEREST"),
  SKILL: createSimpleListActions("SKILL"),
  CAREER: createSimpleListActions("CAREER"),
  PERSONALITY: createSimpleListActions("PERSONALITY"),
  COURSE: createSimpleListActions("COURSE"),
  STUDY: createSimpleListActions("STUDY"),
  // Subject Related
  recommendationsFetch: {
    begin: "RECOMMENDATIONS_FETCH_BEGIN",
    success: "RECOMMENDATIONS_FETCH_SUCCESS",
    failure: "RECOMMENDATIONS_FETCH_FAILURE"
  },

  saveDraft: {
    begin: "SAVE_DRAFT_BEGIN",
    success: "SAVE_DRAFT_SUCCESS",
    failure: "SAVE_DRAFT_FAILURE"
  },
  // General
  email: "EMAIL_UPDATE",
  emailSummary: {
    begin: "EMAIL_SUMMARY_BEGIN",
    success: "EMAIL_SUMMARY_SUCCESS",
    failure: "EMAIL_SUMMARY_FAILURE"
  },
  recommendedSubjects: "RECOMMENDED_SUBJECTS",
  otherSubjects: "OTHER_SUBJECTS",
  additionalSubjects: "ADDITIONAL_SUBJECTS",

  // User Subject Input
  pickRecSubs: "PICK_RECOMMENDED_SUBJECTS",
  pickOthSubs: "PICK_OTHER_SUBJECTS",
  pickAddSubs: "PICK_ADDTIONAL_SUBJECTS",

  // ATAR Related
  eligibilityFetch: {
    begin: "ELIGIBILITY_FETCH_BEGIN",
    success: "ELIGIBILITY_FETCH_SUCCESS",
    failure: "ELIGIBILITY_FETCH_FAILURE"
  },
  hash: "HASH_UPDATE"
};
